import { render, staticRenderFns } from "./CreateProduct copy.vue?vue&type=template&id=a3e4f436&scoped=true"
import script from "./CreateProduct copy.vue?vue&type=script&lang=js"
export * from "./CreateProduct copy.vue?vue&type=script&lang=js"
import style0 from "./CreateProduct copy.vue?vue&type=style&index=0&id=a3e4f436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e4f436",
  null
  
)

export default component.exports